import { Routes } from '@angular/router';
import { ProviderComponent } from './pages';

export const providerRoutes: Routes = [
    { path: ':clientCode/provider', component: ProviderComponent }
];
